function viewCartDataLayer(items) {
  if (!window.location.href.endsWith('/cart') || items.length === 0) return;

  const dataToSend = [];
  items.forEach((el) => {
    let values = el.innerHTML.split(',');
    let quantity = document.querySelector(
      `.quantity_dataLayer_checkout_start-${values[1]}`
    );

    if (quantity) {
      dataToSend.push({
        item_id: values[0],
        shopifyProductId: values[1] * 1,
        item_name: values[2],
        price: (values[3] / 100).toFixed(2),
        quantity: quantity.value,
        currency: 'EUR',
      });
    }
  });

  let sum = 0;
  if (dataToSend.length) {
    sum = dataToSend.reduce((a, b) => a + Number(b.price * b.quantity), 0);
  }

  if (window.dataLayer) {
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: 'view_cart',
      ecommerce: {
        currency: 'EUR',
        value: sum.toFixed(2),
        items: dataToSend,
      },
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('checkout');

  if (button) {
    const cartItems = Array.from(
      document.querySelectorAll('.hidden_datalayer_checkout_section')
    );

    viewCartDataLayer(cartItems);
  }
});
